import React, { useEffect, useState } from 'react';
import './style.css';

import { getChamamentos } from '../../services/api.furg';
import { decodeHexHtmlCharCodes } from '../../services/utils';

/* Componentes */
import Chamamento from '../../components/Chamamento';
import { Alert } from '../../components/Alert';
import { Loading } from '../../components/Loading';
import { Content } from '../../components/Content';

const Chamamentos = () => {
    const [error, setError] = useState('');
    const [chamamentos, setChamamentos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        getChamamentos()
            .then(chamamentos => {
                setChamamentos(chamamentos);
                setLoading(false);
            })
            .catch(err => {
                setError(decodeHexHtmlCharCodes(err));
                setLoading(false);
            });
    }, []);

    return (
        <Content title="Solicitação de matrícula on-line" subtitle={!loading && !!chamamentos.length && 'Escolha o processo seletivo para envio da sua documentação'}>
            <div className="container-fluid chamamento-grid" style={{ maxWidth: 1024 }}>
                {error && <Alert variant="danger">{error}</Alert>}
                {loading ? (
                    <Loading />
                ) : (
                    <>
                        {!error && !chamamentos.length && (
                            <Alert variant="light" icon={false}>
                                Nenhum processo em andamento no momento.
                            </Alert>
                        )}

                        {chamamentos.map((chamamento, index) => (
                            <Chamamento key={index} className="chamamento-grid__item" {...chamamento} />
                        ))}
                    </>
                )}
            </div>
        </Content>
    );
};
export default Chamamentos;
